import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import SplitPane from 'react-split-pane'
import { debounce } from '../../../../utils/debounce'
import { selectOrientationSetting } from '../../../../utils/slices/settings.slice'
import { updatePaneClassName } from '../../common/fns'
import Input from '../../views/Input/Input'
import Output from '../../views/Output/Output'

const DesktopView = () => {
  const myRef = useRef(null)
  const orientation = useSelector(selectOrientationSetting)

  let mediaClass = '-media-md'

  const adjustPaneWidthHeight = () => {
    if (!myRef.current) {
      return
    }
    const pane1 = myRef.current.pane1
    const pane2 = myRef.current.pane2

    if (myRef.current.props.split === 'vertical') {
      updatePaneClassName(pane1, pane1.offsetWidth)
      updatePaneClassName(pane2, pane2.offsetWidth)
    } else {
      updatePaneClassName(pane1, pane1.offsetHeight)
      updatePaneClassName(pane2, pane2.offsetHeight)
    }
  }

  const handleDragging = debounce(adjustPaneWidthHeight, 200)

  useEffect(() => {
    adjustPaneWidthHeight()
    const handleResize = () => {
      adjustPaneWidthHeight()
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [orientation])

  return (
    <SplitPane
      ref={myRef}
      defaultSize="36%"
      split={orientation}
      minSize={mediaClass === '-media-md' ? 26 : 32}
      onChange={handleDragging}
    >
      <Input />
      <Output />
    </SplitPane>
  )
}

export default DesktopView
